module.exports = __webpack_public_path__ + "static/media/logo.6d4c3cd0.jpg";